var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _rect3, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOpinionServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 105,
    viewBox: "0 0 130 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9431 20.1419L21.0917 38.6286L50.2615 54.4429L69.9164 31.7782C69.9164 31.7782 78.5968 32.6877 79.5637 32.8644C86.3908 34.1116 91.8785 31.0851 95.4239 27.7782C97.4696 25.8702 96.138 22.8167 93.3807 22.3445L67.9048 17.9819C63.4643 17.2215 58.8971 17.9826 54.9431 20.1419Z",
    fill: "#FFDCD5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.21,
    y: 4.90723,
    width: 95,
    height: 10,
    transform: "rotate(33.9563 46.21 4.90723)",
    fill: "#3A7EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1445 42.7979L107.88 30.9843C111.162 30.5268 114.193 32.8164 114.651 36.0984L114.845 37.4928C115.303 40.7748 113.013 43.8062 109.731 44.2638L24.9959 56.0773L23.1445 42.7979Z",
    fill: "#FFDCD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7686 51.3262L98.2908 48.8512C101.603 48.7397 104.378 51.3341 104.489 54.6459L104.574 57.1697C104.686 60.4815 102.091 63.2567 98.7795 63.3682L25.2572 65.8432L24.7686 51.3262Z",
    fill: "#FFDCD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8926 65.8545L92.6692 63.5729C95.9811 63.4614 98.7562 66.0558 98.8677 69.3677L98.9151 70.7748C99.0266 74.0866 96.4322 76.8617 93.1203 76.9732L25.3437 79.2548L24.8926 65.8545Z",
    fill: "#FFDCD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8057 79.2725L89.6502 77.0896C92.962 76.9781 95.7372 79.5725 95.8486 82.8843L95.896 84.2914C96.0075 87.6033 93.4131 90.3784 90.1013 90.4899L25.2568 92.6728L24.8057 79.2725Z",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2695,
    y: 40.7725,
    width: 67.7839,
    height: 25.7484,
    transform: "rotate(-2.3439 17.2695 40.7725)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24.5811,
    height: 64.597,
    rx: 4,
    transform: "matrix(-0.999997 0.00244765 0.00244765 0.999997 26.626 30.8945)",
    fill: "#374969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.676 67.1488L119.416 66.2729L125.007 57.9706L129.676 67.1488Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpinionServiceMain);
export default __webpack_public_path__ + "static/media/IcOpinionServiceMain.3b3ff98e74aea252f3efef4e103de8af.svg";
export { ForwardRef as ReactComponent };